import React from 'react';

class ButtonTest extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div >
        按钮测试
      </div>
    )
  }
}
export default ButtonTest;


// WEBPACK FOOTER //
// ./example/button_test/index.js